import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    HttpContentWithData,
    HttpResponse,
    RQAPICallWithData,
} from 'store/APIClient';
import { useDispatch } from 'store/hooks';
import { Project } from 'routes/BudgetModule/shared/useGetProjects';
import { useTranslation } from 'react-i18next';

export function useAddProject() {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation({
        mutationFn: ({
            newProjectName,
        }: {
            newProjectName: string;
        }): Promise<HttpResponse<HttpContentWithData<Project>>> =>
            RQAPICallWithData({
                endpoint: 'projects',
                body: { name: newProjectName },
                method: 'POST',
            }),

        onSuccess: (response) => {
            dispatch.vision.notifyUser({
                message: response.content.message,
                snackType: 'success',
            });

            queryClient.setQueryData(['projects'], (oldProjects: Project[]) => [
                ...oldProjects,
                response.content.data,
            ]);
        },

        onError: (error: Error) => {
            let errorMessage = error.message;
            if (errorMessage === 'Object already exists') {
                errorMessage = t(
                    'adminBudgetSpace.addProjectModal.existingNameError',
                );
            }
            dispatch.vision.notifyUser({
                message: errorMessage,
                snackType: 'error',
            });
        },
    });
}
